// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { BlockedTenantRecordDTO } from '../models';
import { CreateBlockedTenantDTO } from '../models';
/**
 * BlockedTenantsApi - axios parameter creator
 * @export
 */
export const BlockedTenantsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Block a tenant email from being added to new Reposits
         * @param {CreateBlockedTenantDTO} createBlockedTenantDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBlockedTenant(createBlockedTenantDTO: CreateBlockedTenantDTO, options: any = {}): RequestArgs {
            // verify required parameter 'createBlockedTenantDTO' is not null or undefined
            if (createBlockedTenantDTO === null || createBlockedTenantDTO === undefined) {
                throw new RequiredError('createBlockedTenantDTO','Required parameter createBlockedTenantDTO was null or undefined when calling createBlockedTenant.');
            }
            const localVarPath = `/v2/blocked-tenants`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"CreateBlockedTenantDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(createBlockedTenantDTO !== undefined ? createBlockedTenantDTO : {}) : (createBlockedTenantDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Unblock a tenant email so it can be added to new Reposits
         * @param {string} email Email address of the blocked tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBlockedTenant(email: string, options: any = {}): RequestArgs {
            // verify required parameter 'email' is not null or undefined
            if (email === null || email === undefined) {
                throw new RequiredError('email','Required parameter email was null or undefined when calling deleteBlockedTenant.');
            }
            const localVarPath = `/v2/blocked-tenants`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a blocked tenant by email
         * @param {string} email Email address of the blocked tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockedTenant(email: string, options: any = {}): RequestArgs {
            // verify required parameter 'email' is not null or undefined
            if (email === null || email === undefined) {
                throw new RequiredError('email','Required parameter email was null or undefined when calling getBlockedTenant.');
            }
            const localVarPath = `/v2/blocked-tenants`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BlockedTenantsApi - functional programming interface
 * @export
 */
export const BlockedTenantsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Block a tenant email from being added to new Reposits
         * @param {CreateBlockedTenantDTO} createBlockedTenantDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBlockedTenant(createBlockedTenantDTO: CreateBlockedTenantDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<BlockedTenantRecordDTO> {
            const localVarAxiosArgs = BlockedTenantsApiAxiosParamCreator(configuration).createBlockedTenant(createBlockedTenantDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Unblock a tenant email so it can be added to new Reposits
         * @param {string} email Email address of the blocked tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBlockedTenant(email: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = BlockedTenantsApiAxiosParamCreator(configuration).deleteBlockedTenant(email, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get a blocked tenant by email
         * @param {string} email Email address of the blocked tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockedTenant(email: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<BlockedTenantRecordDTO> {
            const localVarAxiosArgs = BlockedTenantsApiAxiosParamCreator(configuration).getBlockedTenant(email, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * BlockedTenantsApi - factory interface
 * @export
 */
export const BlockedTenantsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Block a tenant email from being added to new Reposits
         * @param {CreateBlockedTenantDTO} createBlockedTenantDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBlockedTenant(createBlockedTenantDTO: CreateBlockedTenantDTO, options?: any) {
            return BlockedTenantsApiFp(configuration).createBlockedTenant(createBlockedTenantDTO, options)(axios, basePath);
        },
        /**
         * Unblock a tenant email so it can be added to new Reposits
         * @param {string} email Email address of the blocked tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBlockedTenant(email: string, options?: any) {
            return BlockedTenantsApiFp(configuration).deleteBlockedTenant(email, options)(axios, basePath);
        },
        /**
         * Get a blocked tenant by email
         * @param {string} email Email address of the blocked tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockedTenant(email: string, options?: any) {
            return BlockedTenantsApiFp(configuration).getBlockedTenant(email, options)(axios, basePath);
        },
    };
};

/**
 * BlockedTenantsApi - interface
 * @export
 * @interface BlockedTenantsApi
 */
export interface BlockedTenantsApiInterface {
    /**
     * Block a tenant email from being added to new Reposits
     * @param {CreateBlockedTenantDTO} createBlockedTenantDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlockedTenantsApiInterface
     */
    createBlockedTenant(createBlockedTenantDTO: CreateBlockedTenantDTO, options?: any): AxiosPromise<BlockedTenantRecordDTO>;

    /**
     * Unblock a tenant email so it can be added to new Reposits
     * @param {string} email Email address of the blocked tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlockedTenantsApiInterface
     */
    deleteBlockedTenant(email: string, options?: any): AxiosPromise<object>;

    /**
     * Get a blocked tenant by email
     * @param {string} email Email address of the blocked tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlockedTenantsApiInterface
     */
    getBlockedTenant(email: string, options?: any): AxiosPromise<BlockedTenantRecordDTO>;

}

/**
 * BlockedTenantsApi - object-oriented interface
 * @export
 * @class BlockedTenantsApi
 * @extends {BaseAPI}
 */
export class BlockedTenantsApi extends BaseAPI implements BlockedTenantsApiInterface {
    /**
     * Block a tenant email from being added to new Reposits
     * @param {CreateBlockedTenantDTO} createBlockedTenantDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlockedTenantsApi
     */
    public createBlockedTenant(createBlockedTenantDTO: CreateBlockedTenantDTO, options?: any) {
        return BlockedTenantsApiFp(this.configuration).createBlockedTenant(createBlockedTenantDTO, options)(this.axios, this.basePath);
    }

    /**
     * Unblock a tenant email so it can be added to new Reposits
     * @param {string} email Email address of the blocked tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlockedTenantsApi
     */
    public deleteBlockedTenant(email: string, options?: any) {
        return BlockedTenantsApiFp(this.configuration).deleteBlockedTenant(email, options)(this.axios, this.basePath);
    }

    /**
     * Get a blocked tenant by email
     * @param {string} email Email address of the blocked tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlockedTenantsApi
     */
    public getBlockedTenant(email: string, options?: any) {
        return BlockedTenantsApiFp(this.configuration).getBlockedTenant(email, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for BlockedTenantsApi
 * Import individual functions for optimal bundle size
 */
/**
 * Block a tenant email from being added to new Reposits
 * @param {CreateBlockedTenantDTO} createBlockedTenantDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function createBlockedTenant(
    createBlockedTenantDTO: CreateBlockedTenantDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<BlockedTenantRecordDTO> {
    const localVarAxiosArgs = BlockedTenantsApiAxiosParamCreator(configuration).createBlockedTenant(createBlockedTenantDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Unblock a tenant email so it can be added to new Reposits
 * @param {string} email Email address of the blocked tenant
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function deleteBlockedTenant(
    email: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<object> {
    const localVarAxiosArgs = BlockedTenantsApiAxiosParamCreator(configuration).deleteBlockedTenant(email, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get a blocked tenant by email
 * @param {string} email Email address of the blocked tenant
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getBlockedTenant(
    email: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<BlockedTenantRecordDTO> {
    const localVarAxiosArgs = BlockedTenantsApiAxiosParamCreator(configuration).getBlockedTenant(email, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

